import { configureStore } from '@reduxjs/toolkit';
import { iraceDbApi } from '../services/iracedb';

export default configureStore({
  reducer: {
    [iraceDbApi.reducerPath]: iraceDbApi.reducer,
  },
  middleware: (middlewares) => middlewares().concat(iraceDbApi.middleware),
});
